export default "__VITE_ASSET__CK9o_E6e__"